<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ oopt.transName }}</h1>
    <div class="workroom-pg">
      <div class="bgw-pdg-20 passport-pg create">
        <h3 class="title">
          {{ $t('Паспорт') }}
          <router-link tag="a"
            :to="{ name: 'View', params: { id: oopt.id } }"
            target="_blank"
            v-if="oopt.status === 1"
          >
            <img src="@/assets/img/collapse-icon.png" alt="icon">
          </router-link>
        </h3>
        <div class="tab-main">
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            @submit.prevent="updateOopt"
          >
            <v-tabs
              background-color="white"
              left
              v-model="langTab"
            >
              <v-tab>Русский</v-tab>
              <v-tab>Кыргызча</v-tab>
              <v-tab>English</v-tab>
              <v-tab-item v-for="tabItem in tabItems" :key="tabItem.name">
                <div :class="{ 'form-label-copy': !tabItem.main }">
                  <!-- Организационно-правовая форма -->
                  <v-row v-if="tabItem.main" :class="{ invalid: $v.oopt.legalForm.$error }">
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>
                        {{ $t('Организационно-правовая форма') }}: <span class="asterix">*</span>
                        <fieldInfo :info="$t('Организационно-правовая форма')"/>
                      </v-label>
                    </v-col>
                    <v-col class="input-field">
                      <div class="select-def">
                        <v-select
                          :items="data.refLegalForm"
                          return-value
                          item-value="id"
                          item-text="transName"
                          v-model="oopt.legalForm"
                          outlined
                          dense
                          required
                          clearable
                        />
                      </div>
                    </v-col>
                  </v-row>
                  <!-- Название -->
                  <v-row :class="{ invalid: $v.oopt.name.$error && tabItem.main }">
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>
                        {{ $t('Наименование') }}: <span v-if="tabItem.main" class="asterix">*</span>
                        <fieldInfo :info="$t('Наименование')"/>
                      </v-label>
                    </v-col>
                    <v-col class="input-field">
                      <Copy v-if="!tabItem.main" :original="oopt[tabItem.nameMain]" @copyText="copyText($event, tabItem.name)"/>
                      <v-text-field
                        v-model="oopt[tabItem.name]"
                        required
                        outlined
                        dense
                        clearable
                      />
                    </v-col>
                  </v-row>
                  <!-- ИНН -->
                  <v-row v-if="tabItem.main">
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>
                        {{ $t('ИНН') }}:
                        <fieldInfo :info="$t('ИНН')"/>
                      </v-label>
                    </v-col>
                    <v-col class="input-field">
                      <v-text-field
                        v-model="oopt.inn"
                        outlined
                        dense
                        clearable
                        maxlength="14"
                      />
                    </v-col>
                  </v-row>
                  <!-- ОКПО -->
                  <v-row v-if="tabItem.main">
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>
                        {{ $t('ОКПО') }}:
                        <fieldInfo :info="$t('ОКПО')"/>
                      </v-label>
                    </v-col>
                    <v-col class="input-field">
                      <v-text-field
                        v-model="oopt.okpo"
                        outlined
                        dense
                        clearable
                        maxlength="8"
                      />
                    </v-col>
                  </v-row>
                  <!-- Территория по соате -->
                  <v-row :class="{ invalid: $v.oopt.soateTerritories.$error }">
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>
                        {{ $t('Территория по СОАТЕ') }}: <span class="asterix">*</span>
                        <fieldInfo :info="$t('Территория по СОАТЕ')"/>
                      </v-label>
                    </v-col>
                    <v-col class="input-field o-visible">
                      <treeselect
                        v-model="oopt.soateTerritories"
                        :multiple="true"
                        :value-consists-of="'BRANCH_PRIORITY'"
                        :options="data.soates"
                        searchable="searchable"
                        clearable="clearable"
                        :placeholder="$t('Территория по СОАТЕ')"
                      />
                    </v-col>
                  </v-row>
                  <!-- Месторасположение -->
                  <v-row :class="{ invalid: $v.oopt.geoLocation.$error && tabItem.main }">
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>
                        {{ $t('Месторасположение') }}: <span v-if="tabItem.main" class="asterix">*</span>
                        <fieldInfo :info="$t('Месторасположение')"/>
                      </v-label>
                    </v-col>
                    <v-col class="input-field">
                      <Copy v-if="!tabItem.main" :original="oopt[tabItem.geoLocationMain]" @copyText="copyText($event, tabItem.geoLocation)"/>
                      <ckeditor
                        :editor="editor"
                        v-model="oopt[tabItem.geoLocation]"
                        :config="editorConfig"
                      />
                    </v-col>
                  </v-row>
                  <!-- ФИО руководителя -->
                  <v-row :class="{ invalid: $v.oopt.headFullName.$error && tabItem.main }">
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>
                        {{ $t('ФИО руководителя') }}: <span v-if="tabItem.main" class="asterix">*</span>
                        <fieldInfo :info="$t('ФИО руководителя')"/>
                      </v-label>
                    </v-col>
                    <v-col class="input-field">
                      <Copy v-if="!tabItem.main" :original="oopt[tabItem.headFullNameMain]" @copyText="copyText($event, tabItem.headFullName)"/>
                      <v-text-field
                        v-model="oopt[tabItem.headFullName]"
                        required
                        outlined
                        dense
                        clearable
                      />
                    </v-col>
                  </v-row>
                  <!-- Должность руководителя -->
                  <v-row :class="{ invalid: $v.oopt.headPosition.$error && tabItem.main }">
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>
                        {{ $t('Должность руководителя') }}: <span v-if="tabItem.main" class="asterix">*</span>
                        <fieldInfo :info="$t('Должность руководителя')"/>
                      </v-label>
                    </v-col>
                    <v-col class="input-field">
                      <Copy v-if="!tabItem.main" :original="oopt[tabItem.headPositionMain]" @copyText="copyText($event, tabItem.headPosition)"/>
                      <v-text-field
                        v-model="oopt[tabItem.headPosition]"
                        required
                        outlined
                        dense
                        clearable
                      />
                    </v-col>
                  </v-row>
                  <!-- Населенный пункт -->
                  <v-row :class="{ invalid: $v.oopt.locality.$error }">
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>
                        {{ $t('Населенный пункт') }}: <span class="asterix">*</span>
                        <fieldInfo :info="$t('Населенный пункт')"/>
                      </v-label>
                    </v-col>
                    <v-col class="input-field o-visible">
                      <treeselect
                        v-model="oopt.locality"
                        :multiple="false"
                        :options="data.soates"
                        searchable="searchable"
                        clearable="clearable"
                        :placeholder="$t('Населенный пункт')"
                      />
                    </v-col>
                  </v-row>
                  <!-- Адрес -->
                  <v-row :class="{ invalid: $v.oopt.legalAddress.$error && tabItem.main }">
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>
                        {{ $t('Юридический адрес') }}: <span v-if="tabItem.main" class="asterix">*</span>
                        <fieldInfo :info="$t('Юридический адрес')"/>
                      </v-label>
                    </v-col>
                    <v-col class="input-field">
                      <Copy v-if="!tabItem.main" :original="oopt[tabItem.legalAddressMain]" @copyText="copyText($event, tabItem.legalAddress)"/>
                      <v-text-field
                        v-model="oopt[tabItem.legalAddress]"
                        required
                        outlined
                        dense
                        clearable
                      />
                    </v-col>
                  </v-row>
                  <!-- Номер телефона -->
                  <v-row v-if="tabItem.main" :class="{ invalid: $v.oopt.phones.$error }">
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>
                        {{ $t('Телефон') }}: <span class="asterix">*</span>
                        <fieldInfo :info="$t('Телефон')"/>
                      </v-label>
                    </v-col>
                    <v-col class="input-field">
                      <Phone
                        v-bind:phones.sync="oopt.phones"
                      />
                    </v-col>
                  </v-row>
                  <!-- Адрес эл. почты -->
                  <v-row v-if="tabItem.main" :class="{ invalid: $v.oopt.email.$error }">
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>
                        Email: <span class="asterix">*</span>
                        <fieldInfo :info="'Email'"/>
                      </v-label>
                    </v-col>
                    <v-col class="input-field">
                      <v-text-field
                        v-model="oopt.email"
                        type="email"
                        required
                        outlined
                        dense
                        clearable
                      />
                    </v-col>
                  </v-row>
                  <!-- Учредители -->
                  <v-row v-if="oopt.huntingFarm">
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>
                        {{ $t('Учредители') }}:
                        <fieldInfo :info="$t('Учредители')"/>
                      </v-label>
                    </v-col>
                    <v-col class="input-field">
                      <Copy v-if="!tabItem.main" :original="oopt[tabItem.foundersMain]" @copyText="copyText($event, tabItem.founders)"/>
                      <v-textarea
                        v-model="oopt[tabItem.founders]"
                        required
                        outlined
                        dense
                        clearable
                      />
                    </v-col>
                  </v-row>
                  <v-row v-if="tabItem.main && oopt.huntingFarm">
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>
                        {{ $t('Отчетность и БСО') }}:
                        <fieldInfo :info="$t('Отчетность и БСО')"/>
                      </v-label>
                    </v-col>
                    <v-col class="input-field">
                      <div class="select-def">
                        <v-select
                          :items="data.refDepartmentOopt"
                          return-value
                          item-value="id"
                          item-text="transName"
                          v-model="oopt.ooptReportingBso"
                          outlined
                          dense
                          clearable
                        />
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-tab-item>
            </v-tabs>
            <div class="form-action">
              <button
                class="btn btn-default blue"
                type="submit"
              >
                {{ $t('Сохранить') }}
              </button>
              <button
                type="button"
                class="btn btn-default gray"
                @click="onCancel"
              >
                {{ $t('Отмена') }}
              </button>
            </div>
          </v-form>
        </div>
      </div>
    </div>
  </v-container>
</template>
<script>
import OOPT from '@/model/oopt'
import fieldInfo from '@/components/app/fieldInfo'
import Copy from '@/components/oopt/Copy'
import Phone from '@/components/oopt/Phone'
import { required, email } from 'vuelidate/lib/validators'
import { mapMutations } from 'vuex'

// tree select
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

// ckeditor
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials'
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold'
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic'
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link'
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph'
import HeadingPlugin from '@ckeditor/ckeditor5-heading/src/heading'
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment'
import HorizontalLine from '@ckeditor/ckeditor5-horizontal-line/src/horizontalline'
import Table from '@ckeditor/ckeditor5-table/src/table'
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar'

export default {
  components: {
    Phone,
    fieldInfo,
    Copy,
    Treeselect
  },
  data () {
    return {
      data: [],
      oopt: {},
      formData: {},
      langTab: null,
      valid: true,
      breadcrumbs: [],
      rules: {
        oopt: {
          name: { required },
          legalForm: { required },
          soateTerritories: { required },
          geoLocation: { required },
          headFullName: { required },
          headPosition: { required },
          locality: { required },
          legalAddress: { required },
          phones: { required },
          email: { required, email }
        }
      },
      tabItems: [
        {
          main: true,
          name: 'name',
          geoLocation: 'geoLocation',
          headFullName: 'headFullName',
          headPosition: 'headPosition',
          legalAddress: 'legalAddress',
          founders: 'founders'
        },
        {
          main: false,
          nameMain: 'name',
          geoLocationMain: 'geoLocation',
          headFullNameMain: 'headFullName',
          headPositionMain: 'headPosition',
          legalAddressMain: 'legalAddress',
          foundersMain: 'founders',
          name: 'nameKg',
          legalEntityName: 'legalEntityNameKg',
          geoLocation: 'geoLocationKg',
          headFullName: 'headFullNameKg',
          headPosition: 'headPositionKg',
          legalAddress: 'legalAddressKg',
          founders: 'foundersKg'
        },
        {
          main: false,
          nameMain: 'name',
          geoLocationMain: 'geoLocation',
          headFullNameMain: 'headFullName',
          headPositionMain: 'headPosition',
          legalAddressMain: 'legalAddress',
          foundersMain: 'founders',
          name: 'nameEn',
          geoLocation: 'geoLocationEn',
          headFullName: 'headFullNameEn',
          headPosition: 'headPositionEn',
          legalAddress: 'legalAddressEn',
          founders: 'foundersEn'
        }
      ],
      // editor
      editor: ClassicEditor,
      editorData: '',
      editorConfig: {
        plugins: [
          EssentialsPlugin,
          BoldPlugin,
          ItalicPlugin,
          LinkPlugin,
          ParagraphPlugin,
          HeadingPlugin,
          HorizontalLine,
          Alignment,
          Table,
          TableToolbar
        ],
        toolbar: [
          'heading',
          '|',
          'bold',
          'italic',
          'link',
          'alignment',
          '|',
          'horizontalLine',
          '|',
          'undo',
          'redo',
          '|',
          'insertTable'
        ],
        table: {
          contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
        },
        heading: {
          options: [
            {
              model: 'paragraph',
              title: 'Paragraph',
              class: 'ck-heading_paragraph'
            },
            {
              model: 'heading1',
              view: 'h1',
              title: 'Heading 1',
              class: 'ck-heading_heading1'
            },
            {
              model: 'heading2',
              view: 'h2',
              title: 'Heading 2',
              class: 'ck-heading_heading2'
            },
            {
              model: 'heading3',
              view: 'h3',
              title: 'Heading 3',
              class: 'ck-heading_heading3'
            }
          ]
        }
      }
    }
  },
  validations () {
    return this.rules
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    ...mapMutations(['setLoading']),

    // Данные для формы редактирования
    fetchData () {
      this.setLoading(true)

      OOPT.getOoptEditFormData(this.$route.params.id, 'otherPassport')
        .then((response) => {
          this.data = response.data
          this.oopt = { ...this.data.oopt }
          this.breadcrumbs = [
            { text: this.$i18n.t('Главная'), disabled: false, href: '/' },
            { text: this.$i18n.t('Рабочий кабинет'), disabled: false, href: '/my-organization' },
            { text: this.oopt.transName, disabled: false, href: '/my-organization?id=' + this.oopt.id },
            { text: this.$i18n.t('Редактирование паспорта'), disabled: true }
          ]
          this.setLoading(false)
        })
        .catch((error) => {
          this.$router.push({
            name: 'error',
            params: {
              status: error.response.status
            }
          })
          this.setLoading(false)
        })
    },
    // Валидация формы
    validateForm () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    // Обновление списка НПА
    updateNpaList (lists) {
      this.data.refNpa = lists
    },
    // Обновление списка группы ООПТ
    updateOoptGroupList (lists) {
      this.data.ooptGroup = lists
    },
    // Обновление ООПТ
    updateOopt () {
      if (!this.validateForm()) {
        return
      }
      this.setLoading(true)

      this.formData = { ...this.oopt }
      // удаление лишних свойств
      delete this.formData.id
      delete this.formData.transName
      delete this.formData.status
      delete this.formData.huntingFarm
      delete this.formData.type

      // Корректная обработка полей типа Object
      if (this.formData.legalForm instanceof Object) {
        this.formData.legalForm = this.formData.legalForm.id
      }
      if (this.formData.ooptReportingBso === undefined) {
        this.formData.ooptReportingBso = null
      }
      if (this.formData.ooptReportingBso instanceof Object) {
        this.formData.ooptReportingBso = this.formData.ooptReportingBso.id
      }

      OOPT.updateOopt(this.oopt.id, 'otherPassport', this.formData)
        .then((response) => {
          if (response.status === 200) {
            this.$noty.success(this.$i18n.t('Успешно обновлено'), {
              killer: true,
              timeout: 1000,
              layout: 'topRight'
            })
            this.setLoading(false)
            this.$router.push({
              name: 'MyOrganization'
            })
          }
        })
        .catch((error) => {
          let msg = error.message
          if (error.response) {
            if (error.response.data.form) {
              msg = this.$i18n.t(error.response.data.form.message)
            } else if (error.response.data.message) {
              msg = this.$i18n.t(error.response.data.message)
            }
          }
          this.validateForm()
          this.$noty.error(msg, {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
          this.setLoading(false)
        })
    },
    // Отмена
    onCancel () {
      this.$router.push({
        name: 'MyOrganization'
      })
    },
    // Копирование текста для мультиязычности
    copyText (title, refName) {
      this.oopt[refName] = title
    },
    // Прокручивание до поля с ошибкой
    scrollToFirstError () {
      this.langTab = 0
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>
